import React from 'react';
import { Tooltip } from 'react-tooltip';
import AdvisoriesSummaryProps from '../interfaces/AdvisoriesSummaryProps';
import AdvisoryRetire from './AdvisoryRetire';

const AdvisoriesSummaryRetire: React.FC<AdvisoriesSummaryProps> = ({ report }) => {
    return <ul>
        {Object.keys(report.vulnerabilities).map((packageIdentifier: string) => (
            <li key={packageIdentifier}>
                <strong>{report.vulnerabilities[packageIdentifier].title}</strong>
                <ul>
                    <li>
                        <a href={report.vulnerabilities[packageIdentifier].url_list[0]} target="_blank" rel="noreferrer" data-tooltip-id={`tooltip-${packageIdentifier}`}>{report.vulnerabilities[packageIdentifier].title}</a>
                        <Tooltip
                            id={`tooltip-${packageIdentifier}`}
                            place="bottom"
                        >
                            <AdvisoryRetire
                                packageName={report.vulnerabilities[packageIdentifier].title}
                                advisory={report.vulnerabilities[packageIdentifier]}
                            />
                        </Tooltip>
                    </li>
                </ul>                
            </li>
        ))}
    </ul>;
}

export default AdvisoriesSummaryRetire;